import { PaginatedChatsTable } from "./PaginatedChatsTable";

function ChatsTable() {
  return (
    <PaginatedChatsTable showFilters showSupportFilter defaultPageSize={20} />
  );
}

export { ChatsTable };
